module.exports = __webpack_public_path__ + "static/media/payroll-agi.0d172910.png";